import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { history } from '../../app/routing/history';
import { getAuth } from '../../app/modules/auth';

const API_URL = process.env.REACT_APP_API_URL;

const usuario = getAuth();

const axiosConfig: AxiosRequestConfig = {
    baseURL: API_URL,
    headers: {
        'x-token': `${usuario?.api_token}`,
    },
};

const apiClient: AxiosInstance = axios.create(axiosConfig);

apiClient.interceptors.response.use(
    (response: AxiosResponse) => {
        console.log('Response:', response);
        return response;
    },
    (error) => {
        if (error.response) {
            const { status } = error.response;
            console.log('Error status:', status);

            // Si el error es 401 (No autorizado), redirigimos al login
            if (status === 304) {
                // Eliminamos el token del localStorage o sessionStorage
                localStorage.removeItem('authToken'); // O sessionStorage, dependiendo de tu implementación
                sessionStorage.removeItem('authToken');

                // Redirigimos al usuario a la página de login
                history.push('/login'); // Asegúrate de que esta ruta sea la correcta
            }
        }

        // Retornamos el error para que pueda ser manejado por el código que llamó a la API
        return Promise.reject(error instanceof Error ? error : new Error(error));
    }
);

export default apiClient;